import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleDoubleRight, faChevronDown, faDownload, faEye, faEyeSlash, faLock, faUser } from '@fortawesome/free-solid-svg-icons';

library.add(
  faUser,
  faLock,
  faDownload,
  faEye,
  faEyeSlash,
  faChevronDown,
  faAngleDoubleRight
);